export default __webpack_public_path__ + "static/media/mw_wheel.d1d3eed4.png";